import * as React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useState, useEffect } from 'react';
import ActionDialog from '../../../../components/shared/Dialog/ActionDialog';
import { useFollowCafeMutation, useUnfollowCafeMutation } from '../../../../store/api/cafeApi';
import {
  PopupNotification,
  toastUnfollow,
  toastFollow,
} from '../../../../components/shared/PopupNotification/PopupNotification';
import { useContext } from 'react';
import { AppContext } from '../../../../context/ContextProvider';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';

const CafeNameContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '30px',
  [theme.breakpoints.down('850')]: {
    gap: '10px',
    width: '400px',
    marginLeft: '70px',
    marginBottom: '5px',
    flexDirection: 'column',
  },
  [theme.breakpoints.down('450')]: {
    marginRight: '95px',
    marginBottom: '3px',
    flexDirection: 'column',
  },
  [theme.breakpoints.down('370')]: {
    marginRight: '115px',
    marginBottom: '3px',
    flexDirection: 'column',
  },
}));
const CafeNameTypography = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: '400',
  fontFamily: 'Fjalla One',
  [theme.breakpoints.down('850')]: {
    marginLeft: '115px',
  },
  [theme.breakpoints.down('450')]: {
    marginLeft: '120px',
  },
}));

const Diamond = styled('div')(() => ({
  color: 'rgb(166,146,123)',
  fontSize: '16px',
}));
const CafeFollowButton = styled(Button)(() => ({
  display: 'flex',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '19px',
  color: '#AB9178',
  alignItems: 'center',
  gap: '6px',
}));

const CafeFollowTypography = styled(Typography)(() => ({
  fontFamily: 'Raleway',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '16px',
  lineHeight: '19px',
  color: '#AB9178',
  width: '74px',
}));

const FollowSpan = styled('span')(() => ({
  color: '#000000',
}));

const EditButton = styled('a')(({ theme }) => ({
  color: '#000000',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '19px',
  textDecoration: 'none',
  textTransform: 'capitalize',
  display: 'flex',
  alignItems: 'center',
  border: 'none',
  marginLeft: '30px',
  '& svg': {
    marginRight: '3px',
    height: '18px',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  [theme.breakpoints.down('850')]: {
    marginLeft: '35px',
  },
  [theme.breakpoints.down('450')]: {
    marginLeft: '15px',
  },
}));

const ButtonContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('850')]: {
    gap: '5px',
    marginLeft: '50px',
  },
  [theme.breakpoints.down('450')]: {
    marginLeft: '55px',
  },
}));

export default function CafeName({ cafeData, currentUser }) {
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);
  const cafeName = cafeData.cafeName;
  const iscurrentUserFollow = cafeData.followedUsers.some((e) => {
    if (e._id === currentUser) {
      return true;
    } else return false;
  });
  const [followCafe] = useFollowCafeMutation();
  const [unfollowCafe] = useUnfollowCafeMutation();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const author = useSelector(selectUser);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickFollow = async () => {
    const cafeId = cafeData._id;
    if (iscurrentUserFollow) {
      await unfollowCafe({ cafeId, userId: currentUser });
      setOpen(false);
      toastUnfollow(cafeName);
    } else {
      await followCafe({ cafeId, userId: currentUser });
      setOpen(false);
      toastFollow(cafeName);
    }
  };
  const handleClickCancel = () => {
    setOpen(false);
  };

  const linkUrl = `/cafe/${cafeData._id}/update`;

  let role = localStorage.getItem('role');

  if (role === 'undefined') {
    role = 1;
  }

  return (
    <CafeNameContainer>
      <CafeNameTypography>{cafeName}</CafeNameTypography>
      {currentUser && isLogin ? (
        <>
          <ButtonContainer>
            <CafeFollowButton onClick={iscurrentUserFollow ? handleOpen : handleClickFollow}>
              <Diamond>{iscurrentUserFollow ? `♦` : <FollowSpan>♦</FollowSpan>}</Diamond>
              <CafeFollowTypography>
                {iscurrentUserFollow ? `Following` : <FollowSpan>Follow</FollowSpan>}
              </CafeFollowTypography>

              {Number(role) === 0 ? (
                <EditButton href={linkUrl}>
                  <SettingsIcon />
                  Edit Cafe
                </EditButton>
              ) : null}
            </CafeFollowButton>
          </ButtonContainer>
        </>
      ) : null}
      <ActionDialog
        img={cafeData.attachments}
        name={cafeName}
        onClose={handleClose}
        open={open}
        variant="cafe"
        action="unfollow"
        actionHandler={handleClickFollow}
        cancelHandler={handleClickCancel}
      />
    </CafeNameContainer>
  );
}
